// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"xca-z","narrowOptionButtons":"yca-z","noOptions":"zca-z"};